import { t } from 'i18next';
import type { ErrorStrategy } from '../types';
import type { I18nKey } from '@/utils/typings';

// ajv-errors nests the error it replaced, so the original keyword's params
// (e.g. `limit`) stay reachable for interpolation.
export const customErrorMessageStrategy: ErrorStrategy = ({ instancePath, message, params }) => {
  return {
    path: instancePath,
    message: t(message as I18nKey, params?.errors?.[0]?.params),
  };
};
